export const visibleObserver = (visibleCallback) => {
    // In a browser, not a mobile app.
    const callback = entries => {
        entries.forEach(entry => {
            visibleCallback(entry.isIntersecting);
        });
    };
    // headless browsers or IE might not have this feature.
    if (window.IntersectionObserver) {
        new IntersectionObserver(callback, {
            threshold: 0.5,
        }).observe(document.querySelector('#root'));
    }
    else {
        visibleCallback(true);
    }
};
